import ContentProdApp from './content_prod_app'
import ContentUatApp from './content_uat_app'
import ContentProOps from './content_proOps'
import ContentFatApp from './content_fat_app'
import ContentDevApp from './content_dev_app'
import ContentLocalDebug from './content_local_debug'
import ContentDevOps from './content_devops'
import ContentOther from './content_other'
import vuex from '../../store'
import $ from 'jquery'
import Vue from "vue";

export default {
  //生成按钮列表
  genButtons() {
    return [{
      id: 1,
      title: 'prod-app',
      content: ContentProdApp.build(),
      isfliter: false, // 不为内部网时是否过滤，true为过滤元素
      isDeveloper: false // 不为开发者，true为开发者才显示
    }, {
      id: 2,
      title: 'proOps',
      content: ContentProOps.build(),
      isfliter: true,
      isDeveloper: true
    },{
    //   id: 4,
    //   title: 'uat-app',
    //   content: ContentUatApp.build(),
    //   isfliter: true,
    //   isDeveloper: true
    // }, {
    //   id: 4,
    //   title: 'fat-app',
    //   content: ContentFatApp.build(),
    //   isfliter: true,
    //   isDeveloper: true
    // }, {
      id: 3,
      title: 'dev-app',
      content: ContentDevApp.build(),
      isfliter: true,
      isDeveloper: true
    }, {
      id: 4,
      title: 'local-debug',
      content: ContentLocalDebug.build(),
      isfliter: true,
      isDeveloper: true
    }, {
      id: 5,
      title: 'other',
      content: ContentOther.build(),
      isfliter: false
    }];
  },
//构建生产应用内容
  buildProdAppContent() {
    return ContentProdApp.build();
  },
  //判断是否在品沃网络中
  refreshNetStatus() {
    vuex.commit('changeInPingworthNet', true)
    // this.refreshInPingworthNet1("https://dev.mars20.pingworth.com")
    // this.refreshInPingworthNet('https://net.mars20.pingworth.com')
  },
  refreshInPingworthNet(url) {
    if (vuex.state.inPingworthNet) { //已经在了，不用调用
      return;
    }
    $.ajax({
      url: url,
      type: 'get',
      dataType: 'text',
      complete: function (XMLHttpRequest, status) {
        if (status == 'success' && XMLHttpRequest.responseText == 'dsdDkn23dsffDnn65t') {
          vuex.commit('changeInPingworthNet', true)
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/content/contents.js